import ApplicationController from "./application_controller";
import { loadGoogleCharts, drawChartFromData } from "../utils/charts";

export default class extends ApplicationController {
  static values = {
    url: String,
    dashId: Number,
    currentApp: String,
    dashPage: String,
    dashName: String,
    graphType: String,
  };
  connect() {
    this.changeColor();

    if (!this.hasUrlValue || !this.hasDashIdValue) {
      console.warn("⚠️ widgetloader: url or dashId missing, skipping.");
      return;
    }

    const dashId = this.dashIdValue;
    const url = this.urlValue;
    const dash_page = this.dashPageValue;
    const current_app = this.currentAppValue;

    this.isChartWidget = false;

    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((html) => {
        this.element.innerHTML = html;

        // Réexécuter les <script> injectés
        const scripts = this.element.querySelectorAll("script");
        scripts.forEach((oldScript) => {
          const newScript = document.createElement("script");
          if (oldScript.src) {
            newScript.src = oldScript.src;
          } else {
            newScript.textContent = oldScript.textContent;
          }
          Array.from(oldScript.attributes).forEach((attr) =>
            newScript.setAttribute(attr.name, attr.value)
          );
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        //$('#cross_widget table').addClass('fx-table-hm cross fx-table-hm-wrapped fx-table-12');
        $('#cross_widget input[type="submit"]').addClass("mt-2 fx-button");

        document.dispatchEvent(new CustomEvent(`dash:load_${dashId}`));

        const graphContainer = this.element.querySelector("[data-chart-data]");
        if (graphContainer?.dataset.chartData) {
          this.isChartWidget = true;
          this.insertChartTypeSelector(graphContainer);

          const gridItem = this.element.closest(".grid-stack-item");

          const gsWidth = parseInt(gridItem.getAttribute("gs-w"), 10);

          const colCount = window.myDashboard.grid.opts.column;
          const gridWidth = window.myDashboard.grid.el.clientWidth;

          const cellWidth = gridWidth / colCount;

          const moreDetailsBlock = document.querySelector(
            `#chart_more_details_${this.dashIdValue}`
          );

          const detailsHeight = moreDetailsBlock?.offsetHeight || 0;

          const gridStackItemContentHeight = this.getFullHeight(
            this.element.closest(".grid-stack-item-content")
          );

          const moreDetailsBlockHeight = this.getFullHeight(
            document.querySelector(`#chart_more_details_${this.dashIdValue}`)
          );

          const chartToolsHeight = this.getFullHeight(
            this.element.querySelector(`#chart_tools_${this.dashIdValue}`)
          );

          const extendTitleHeight = this.getFullHeight(
            this.element.querySelector(".extend_title")
          );

          const barreTitreHeight = this.getFullHeight(
            this.element.querySelector(".barre-titre")
          );

          const contentWrapperGap =
            chartToolsHeight +
            moreDetailsBlockHeight +
            barreTitreHeight +
            extendTitleHeight;
          loadGoogleCharts(() =>
            drawChartFromData(graphContainer, {
              chartWidth: gsWidth * cellWidth - 60,
              chartHeight: gridStackItemContentHeight - contentWrapperGap,
              dashId: this.dashIdValue,
            })
          );

          //  contentWrapper.style.height = `${gsHeight*(5)-83}px`;
        }

        // Gestion formulaire dynamique
        const dynamicForm = document.querySelector(`#form_${this.dashIdValue}`);
        if (dynamicForm) {
          // console.warn("📝 Formulaire dynamique trouvé :", dynamicForm);
          dynamicForm.addEventListener("change", (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            const formData = new FormData(dynamicForm);

            fetch(
              `${current_app}/dash_libraries/filter_dash?vr2=1&dash_library_id=${this.dashIdValue}&dash_page=${dash_page}`,
              {
                method: "POST",
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  "X-CSRF-Token": document.querySelector("[name='csrf-token']")
                    ?.content,
                },
                body: formData,
              }
            )
              .then((response) => {
                if (!response.ok)
                  throw new Error(`Erreur HTTP ${response.status}`);
                return response.text();
              })
              .then((html) => {
                //this.element.innerHTML = html;
                const target = document.querySelector(
                  `#grid-stack-item-content-${this.dashIdValue}`
                );

                target.innerHTML = html;
                this.reconnectGridWidget(this.dashIdValue);

                // $('#cross_widget table').addClass('fx-table-hm cross fx-table-hm-wrapped fx-table-12');
                $('#cross_widget input[type="submit"]').addClass(
                  "mt-2 fx-button"
                );

                document.dispatchEvent(
                  new CustomEvent(`dash:filter:${dashId}`, {
                    detail: { dashId, element: this.element },
                  })
                );

                const updatedContainer =
                  this.element.querySelector("[data-chart-data]");
                if (updatedContainer?.dataset.chartData) {
                  this.removeAjustHandle(gridItem, this.dashIdValue);
                  this.isChartWidget = true;
                  this.insertChartTypeSelector(updatedContainer);
                  loadGoogleCharts(() =>
                    drawChartFromData(updatedContainer, {
                      dashId: this.dashIdValue,
                    })
                  );
                }

                this.notifyDashboardContentUpdated();
              })
              .catch((error) => {
                console.error("❌ Erreur lors du filtrage :", error);
                this.element.innerHTML =
                  "<div class='alert alert-danger fx-flash-error fx-text-box-error p-5'>Erreur lors de l’application du filtre</div>";
              });
          });
        }

        const gridItem = this.element.closest(".grid-stack-item");
        const gstack = this.element.dataset.widgetloaderGridConfigValue;

        if (
          gridItem &&
          (gstack === "{}" ||
            this.isChartWidget ||
            this.isAutoResizeEnabledForItem(gridItem, { dashId: dashId }))
        ) {
          if (this.isChartWidget) {
            const contentWrapper = this.element.querySelector(
              ".content.table-scroll-wrapper"
            );

            let gridStackItemContentHeight = this.getFullHeight(
              this.element.closest(".grid-stack-item-content")
            );

            let moreDetailsBlockHeight = 0;
            const moreDetailsBlock = this.element.querySelector(
              "[data-chart-more-details]"
            );
            if (moreDetailsBlock) {
              moreDetailsBlockHeight = 44;
            }

            let chartToolsHeight = 0;
            const chartToolsBlock = this.element.querySelector(
              "[data-export-csv-label]"
            );
            if (chartToolsBlock) {
              chartToolsHeight = 26;
            }

            let extendTitleHeight = 0;
            const extendTitle = this.element.querySelector(".extend_title");
            if (extendTitle) {
              extendTitleHeight = this.getFullHeight(extendTitle);
            }

            let barreTitreHeight = 0;
            const barreTitre = this.element.querySelector(".barre-titre");
            if (barreTitre) {
              barreTitreHeight = this.getFullHeight(barreTitre);
            }

            const contentWrapperGap =
              chartToolsHeight +
              moreDetailsBlockHeight +
              barreTitreHeight +
              extendTitleHeight;

            let finalHeight =
              gridStackItemContentHeight - contentWrapperGap - 36;

            contentWrapper.style.height = `${
              gridStackItemContentHeight -
              barreTitreHeight -
              extendTitleHeight -
              36
            }px`;

            // this.miniResizeFull({ currentTarget: gridItem });
            this.removeAjustHandle(gridItem, this.dashIdValue);
          }
        }

        // IMPORTANT: on demande au dashboard de recalculer le widget (sans bouger)
        this.notifyDashboardContentUpdated();

        setTimeout(() => {
          const button = document.getElementById(
            `${dashId}_group_drag_adjust_button`
          );
          const targetGroup = document.getElementById(
            `${dashId}_group_actions_buttons`
          );

          if (button && targetGroup) {
            targetGroup.appendChild(button);
          } else {
            console.warn(
              "❗ Aucun button ou targetGroup trouvé dans après délai"
            );
          }
        }, 150);
      })
      .catch((err) => {
        this.element.innerHTML =
          "<div class='alert alert-danger fx-flash-error fx-text-box-error p-5'>Erreur de chargement</div>";
        console.error("❌ AJAX error widgetloader:", err);
      });
  }

  removeAjustHandle(gridItem, dashId) {
    const el = gridItem.querySelector(`#adjust-handle-${dashId}`);
    const el1 = gridItem.querySelector(`#resize-toggle-handle-${dashId}`);

    if (el) {
      el.parentNode.removeChild(el);
    }
    if (el1) {
      el1.parentNode.removeChild(el1);
    }
  }

  reconnectGridWidget(dashId) {
    const grid = window.myDashboard.grid;
    const widgetEl = document.getElementById(`grid-stack-item-${dashId}`);
    if (widgetEl) {
      grid.removeWidget(widgetEl, false);
      grid.makeWidget(widgetEl);
    } else {
      console.warn(`❌ Widget ${dashId} introuvable`);
    }
  }

  getElementHeight(parent, selector, defaultHeight = 0) {
    const element = parent.querySelector(selector);
    if (element) {
      return this.getFullHeight(element);
    }

    return defaultHeight;
  }
  insertChartTypeSelector(container) {
    if (
      !container ||
      container.previousElementSibling?.classList?.contains(
        "chart-type-selector"
      )
    )
      return;

    const chartData = JSON.parse(container.dataset.chartData);
    const chartTypeOptions = chartData[1];
    const availableTypes = Array.isArray(chartTypeOptions)
      ? chartTypeOptions.filter(
          (type) =>
            typeof type === "string" &&
            (type.includes("Chart") || type.includes("Maps"))
        )
      : [];

    // Création du wrapper
    const wrapperDiv = document.createElement("div");
    wrapperDiv.className = "fx-d-flex justify-content-between";
    wrapperDiv.id = `chart_tools_${this.dashIdValue}`;

    if (availableTypes.length > 1) {
      const currentGraphType = this.hasGraphTypeValue
        ? this.graphTypeValue
        : null;

      if (currentGraphType && availableTypes.includes(currentGraphType)) {
        chartData[1][0] = currentGraphType;
        container.dataset.chartData = JSON.stringify(chartData);
        drawChartFromData(container, { dashId: this.dashIdValue });
      }

      const selector = document.createElement("div");
      selector.className = "chart-type-selector";
      selector.innerHTML = `
        <label for="chartTypeSelector">Type: </label>
        <select id="chartTypeSelector">
          ${availableTypes
            .map((type) => {
              const selected = type === currentGraphType ? "selected" : "";
              return `<option value="${type}" ${selected}>${this.getChartLabel(
                type
              )}</option>`;
            })
            .join("")}
        </select>`;

      wrapperDiv.appendChild(selector);

      selector.querySelector("select").addEventListener("change", (e) => {
        const selectedType = e.target.value;
        chartData[1][0] = selectedType;
        container.dataset.chartData = JSON.stringify(chartData);
        drawChartFromData(container, { dashId: this.dashIdValue });
        this.graphTypeValue = selectedType;

        const dashLibraryId = this.dashIdValue;
        const dashPage = this.dashPageValue;
        // this.miniResizeFull({ currentTarget: container });
        fetch(`${this.currentAppValue}/dash_libraries/save_graph_type?vr2=1`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("[name=csrf-token]").content,
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            dash_library_id: dashLibraryId,
            dash_page: dashPage,
            graph_type: selectedType,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              console.warn("❌ Échec de la sauvegarde du graph_type");
            }
          })
          .catch((error) => {
            console.error("Erreur AJAX save_graph_type :", error);
          });
      });
    }

    // Ajout du bouton export
    const exportContainer = document.getElementById(
      `${this.dashNameValue}_export`
    );
    if (exportContainer) {
      exportContainer.style.fontWeight = "normal";
      exportContainer.style.textAlign = "left";
      wrapperDiv.appendChild(exportContainer);

      setTimeout(() => {
        const firstChild = exportContainer.firstElementChild;
        if (firstChild) {
          firstChild.classList.add("m-0");
        } else {
          console.warn(
            "❗ Aucun enfant trouvé dans exportContainer après délai"
          );
        }
      }, 150);
    }

    // Insertion du wrapper avant le graphique
    container.parentNode.insertBefore(wrapperDiv, container);

    // Ajout des "more-details" juste après le wrapperDiv
    const moreDetailsRaw = container.dataset.chartMoreDetails;
    if (moreDetailsRaw) {
      try {
        const moreDetails = JSON.parse(moreDetailsRaw);
        if (Array.isArray(moreDetails) && moreDetails.length > 0) {
          const detailsDiv = document.createElement("div");
          detailsDiv.className = "chart-more-details mt-2";
          detailsDiv.id = `chart_more_details_${this.dashIdValue}`;

          moreDetails.forEach((detail) => {
            const detailLine = document.createElement("div");
            detailLine.textContent = detail;
            detailsDiv.appendChild(detailLine);
          });

          wrapperDiv.parentNode.insertBefore(
            detailsDiv,
            wrapperDiv.nextSibling
          );
        }
      } catch (err) {
        console.error("Erreur parsing data-chart-more-details:", err);
      }
    }
  }

  getChartLabel(type) {
    switch (type) {
      case "PieChart":
        return "Camembert";
      case "ComboChart":
        return "Combinaison";
      case "LineChart":
        return "Lignes";
      case "ColumnChart":
        return "Colonnes";
      case "PieChart":
        return "Camembert";
      case "GeoChart":
        return "Geo Chart";
      case "Maps":
        return "Maps";
      case "GoogleMaps":
        return "Google Maps";

      default:
        return type;
    }
  }

  getNumberOfRecords(dashId) {
    if (!dashId) return 0;
    const badgeEl = document.getElementById(`badge-widget-${dashId}`);
    if (!badgeEl) return 0;
    const digits = (badgeEl.textContent || "").replace(/[^\d-]/g, "");
    const n = Number.parseInt(digits, 10);
    return Number.isFinite(n) ? n : 0;
  }

  getUserAutoResize(itemEl) {
    const icon = itemEl?.querySelector("i[data-auto-resize]");
    if (!icon) return false;
    const v = Number.parseInt(
      icon.dataset.userAutoResize ?? icon.dataset.autoResize ?? "2",
      10
    );
    return v === 1; // true si ON
  }

  setUserAutoResize(itemEl, on) {
    const icon = itemEl?.querySelector("i[data-auto-resize]");
    if (!icon) return;
    icon.dataset.userAutoResize = on ? "1" : "2";
  }

  applyEffectiveUI(itemEl, effectiveOn) {
    const icon = itemEl?.querySelector("i[data-auto-resize]");
    if (!icon) return;
    icon.classList.toggle("fa-toggle-on", effectiveOn);
    icon.classList.toggle("fa-toggle-off", !effectiveOn);
    icon.dataset.autoResize = effectiveOn ? "1" : "2";
  }

  setResizeControlsDisabled(dashId, disabled, reason = "") {
    const toggleWrap = document.getElementById(
      `resize-toggle-handle-${dashId}`
    );
    const adjustWrap = document.getElementById(`adjust-handle-${dashId}`);

    const apply = (wrapEl, fallbackTargetId, originalTextDefault) => {
      if (!wrapEl) return;
      wrapEl.setAttribute("aria-disabled", String(disabled));
      wrapEl.classList.toggle("is-disabled", disabled);

      // Tooltip (ton contrôleur Tippy)
      const host = wrapEl.querySelector('[data-controller="tooltip"]');
      if (host) {
        if (!host.dataset.tooltipOriginalContent) {
          const tid =
            host.dataset.tooltipTargetIdValue || fallbackTargetId || "";
          const tgt = tid ? document.getElementById(tid) : null;
          host.dataset.tooltipOriginalContent =
            tgt?.innerHTML?.trim() || originalTextDefault || "";
        }
        const original =
          host.dataset.tooltipOriginalContent || originalTextDefault || "";
        const content = disabled && reason ? reason : original;

        const tid = host.dataset.tooltipTargetIdValue || fallbackTargetId || "";
        const tgt = tid ? document.getElementById(tid) : null;
        if (tgt) tgt.innerHTML = content;
        if (host._tippy) host._tippy.setContent(content);
      }
    };

    apply(
      toggleWrap,
      `tooltip-content-autoresize-${dashId}`,
      "Activer/désactiver le redimensionnement automatique selon les résultats"
    );
    apply(adjustWrap, `tooltip-content-adjust-${dashId}`, "Ajuster au contenu");

    // IMPORTANT : synchroniser aussi l’icône du toggle selon le blocage
    if (toggleWrap) {
      const userPrefOn = this.getUserAutoResize(toggleWrap);
      const effectiveOn = userPrefOn && !disabled;
      this.applyEffectiveUI(toggleWrap, effectiveOn);
    }
  }

  countTableRowsInWrapper(wrapperId) {
    const wrapper = document.getElementById(wrapperId);
    if (!wrapper) return 0;
    return wrapper.querySelectorAll("tbody > tr").length;
  }

  shouldDisableAutoResize(dashId, limit = 100) {
    const badgeCount = this.getNumberOfRecords(dashId);
    const rowCount = this.countTableRowsInWrapper(
      `table_scroll_wrapper_${dashId}`
    );

    return badgeCount >= limit && rowCount >= limit;
  }
  isAutoResizeEnabledForItem(itemEl, opts = {}) {
    const { dashId, limit = 100, syncUI = true } = opts;
    if (!itemEl) return false;

    const userPrefOn = this.getUserAutoResize(itemEl); // préférence utilisateur (1/2)
    const disabledPolicy = this.shouldDisableAutoResize(dashId, limit); // règle combinée (badge & lignes)
    const effectiveOn = userPrefOn && !disabledPolicy;

    if (syncUI && dashId) {
      this.setResizeControlsDisabled(
        dashId,
        disabledPolicy,
        `Indisponible (≥ ${limit} résultats)`
      );
    }
    this.applyEffectiveUI(itemEl, effectiveOn);
    return effectiveOn;
  }

  onToggleAutoResizeClick(event, { dashId, threshold = 100 } = {}) {
    const container = event.currentTarget.closest('[aria-disabled="true"]');
    if (container && container.getAttribute("aria-disabled") === "true") {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }

    const itemEl =
      document.getElementById(`resize-toggle-handle-${dashId}`) ||
      event.currentTarget;
    const wasOn = this.getUserAutoResize(itemEl);
    setUserAutoResize(itemEl, !wasOn);

    this.isAutoResizeEnabledForItem(itemEl, {
      dashId,
      threshold,
      syncUI: true,
    });
  }

compactYOnlyWidgetsBelow(grid, refNode) {
  if (!grid?.engine?.nodes || !refNode) {
    console.warn("⛔️ Grid or refNode not available.");
    return [];
  }

  const nodes = grid.engine.nodes;

  const refX1 = refNode.x;
  const refX2 = refNode.x + refNode.w - 1;
  let refBottom = refNode.y + refNode.h;

  const targets = nodes
    .filter((n) =>
      n !== refNode &&
      n.y >= refBottom &&
      n.x <= refX2 &&
      (n.x + n.w - 1) >= refX1
    )
    .sort((a, b) => a.y - b.y || a.x - b.x);

  const moved = [];

  this._isInternalGridUpdate = true;
  try {
    grid.batchUpdate();

    for (const node of targets) {
      let newY = refBottom;
      let guard = 0;

      while (
        grid.engine.collide(node, { x: node.x, y: newY, w: node.w, h: node.h }) &&
        guard++ < 500
      ) newY++;

      if (newY !== node.y) {
        grid.engine.moveNode(node, { x: node.x, y: newY, w: node.w, h: node.h });
        moved.push(node);
      }

      refBottom = Math.max(refBottom, newY + node.h);
    }

    grid.commit();
  } finally {
    this._isInternalGridUpdate = false;
  }

  if (typeof grid._updateStyles === "function") grid._updateStyles(true);

  return moved;
}


  closestGridItem() {
    return this.element.closest(".grid-stack-item");
  }
  // -------------------------
  // Event -> fdashboard
  // -------------------------
  notifyDashboardContentUpdated() {
    const gridItem = this.closestGridItem();
    const settingId = gridItem?.dataset?.id; // DashSetting.id (data-id dans ta view)
    if (!settingId) return;

    document.dispatchEvent(
      new CustomEvent("widget:content-updated", {
        detail: {
          settingId, // DashSetting.id
          dashLibraryId: this.dashIdValue, // DashLibrary.id (utile debug)
          isChartWidget: this.isChartWidget === true,
        },
      })
    );
  }

  // Fonction pour récupérer la hauteur d'un élément
  getElementHeight(parent, selector, defaultHeight = 0) {
    const element = parent.querySelector(selector);
    if (element) {
      return defaultHeight;
    }
    return 0;
  }

  check_activity(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const checkbox = event.currentTarget;
    const itemId = checkbox.dataset.itemId;
    const itemType = checkbox.dataset.itemType;
    const isChecked = checkbox.checked;

    const dashWrapper = checkbox.closest("[data-widgetloader-dash-page-value]");
    const dashPage = dashWrapper
      ? dashWrapper.dataset.widgetloaderDashPageValue
      : null;
    const dashLibraryId = dashWrapper
      ? dashWrapper.dataset.widgetloaderDashIdValue
      : null;
    const currentApp = dashWrapper
      ? dashWrapper.dataset.widgetloaderCurrentAppValue
      : null;

    if (!dashPage) {
      console.error("Impossible de récupérer le dash_page.");
      return;
    }

    // console.log(`Checklist - ID: ${itemId}, Type: ${itemType}, Checked: ${isChecked}, DashPage: ${dashPage}`);

    fetch(`/${currentApp}/dash_libraries/check_activity?vr2=1`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          .content,
      },
      body: JSON.stringify({
        item_id: itemId,
        item_type: itemType,
        checked: isChecked,
        dash_library_id: dashLibraryId,
        dash_page: dashPage,
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Erreur HTTP ${response.status}`);
        return response.text();
      })
      .then((html) => {
        //this.element.innerHTML = html;
        const target = document.querySelector(
          `#grid-stack-item-content-${dashLibraryId}`
        );

        target.innerHTML = html;
        this.reconnectGridWidget(dashLibraryId);

        // $('#cross_widget table').addClass('fx-table-hm cross fx-table-hm-wrapped fx-table-12');
        $('#cross_widget input[type="submit"]').addClass("mt-2 fx-button");
      })
      .catch((error) => {
        console.error("Erreur lors de l'appel checklist:", error);
      });
  }
}
